import React from 'react';

import styled from 'styled-components';

import { useStoreLocatorContext } from './hooks';
import { ListViewHeading } from './list-view-heading';
import theme from './theme';

const FullScreenOverlay = styled.div`
  width: 100%;
  background-color: ${theme.backgroundColor};
`;

const FullScreenOverlayBanner = styled.div`
  width: 100%;
  background-color: ${theme.bannerBackgroundColor};
  position: relative;
  padding: 1rem;
  display: flex;
  align-items: center;
`;

const Container = styled.div`
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  z-index: ${Styles.zIndex.top - 1};
`;

const TabContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  position: sticky;
  top: calc(-1 * env(safe-area-inset-top));
  z-index: ${Styles.zIndex.normal};
  background-color: ${theme.backgroundColor};
  padding-bottom: 0.5rem;
  ${Styles.desktop`
    top: 0px;
    margin-top: 2rem;
  `};
`;

const ListView: React.FC<{
  tabsEl: JSX.Element | false;
  tabPanelsEl: JSX.Element;
  searchBarEl: JSX.Element;
}> = ({ tabsEl, tabPanelsEl, searchBarEl }) => {
  const { listViewEnabled, showListView } = useStoreLocatorContext();

  if (!listViewEnabled || !showListView) {
    return null;
  }

  return (
    <FullScreenOverlay>
      <FullScreenOverlayBanner>
        <Container>
          <ListViewHeading />
          {searchBarEl}
        </Container>
      </FullScreenOverlayBanner>
      <div>
        {!!tabsEl && <TabContainer>{tabsEl}</TabContainer>}

        <Container>{tabPanelsEl}</Container>
      </div>
    </FullScreenOverlay>
  );
};

export default ListView;
